import React, { useState } from "react";
import Button from "~/Common-Objects/UI/Forms/Button/Button";
import Select from "~/Common-Objects/UI/Forms/Select/Select";
import TextInput from "~/Common-Objects/UI/Forms/TextInput/TextInput";
import WarningHolder from "~/Common-Objects/UI/Cards/WarningHolder";

export default function FileSettings({ formFile, onSave }) {
  const [limit, setLimit] = useState(formFile.settings?.limit || "");
  const [expiry, setExpiry] = useState(formFile.settings?.expiry || 10);
  const [expiryUnit, setExpiryUnit] = useState(
    formFile.settings?.expiryUnit || "hours"
  );

  function save() {
    if (limit === "timed") return onSave({ limit, expiry, expiryUnit });
    onSave({ limit });
  }

  return (
    <>
      <h2 className="h4 mar-b15">File Settings</h2>

      <p className="mar-b25">
        Set if the file should only be allowed to be downloaded once per contact
        or only within a certain timeframe after the first download.
      </p>

      <Select
        outerClassName="mar-b25"
        data={[
          { label: "No Limits", value: "" },
          { label: "Download Once", value: "once" },
          { label: "Time Limit", value: "timed" },
        ]}
        value={limit}
        onChange={(e) => setLimit(e.target.value)}
      />

      {limit === "timed" && (
        <div className="row mar-b25">
          <div className="col-xs-6">
            <TextInput
              type="number"
              value={expiry}
              onChange={(e) => setExpiry(parseInt(e.target.value))}
            />
          </div>

          <div className="col-xs-6">
            <Select
              data={[
                { label: "Hours", value: "hours" },
                { label: "Days", value: "days" },
                { label: "Months", value: "months" },
              ]}
              value={expiryUnit}
              onChange={(e) => setExpiryUnit(e.target.value)}
            />
          </div>
        </div>
      )}

      {limit === "timed" && (
        <WarningHolder className="mar-b25">
          Once a contact has downloded this file the first time the link will
          work for {expiry} {expiryUnit}
        </WarningHolder>
      )}

      {limit === "once" && (
        <WarningHolder className="mar-b25">
          Each contact will only be able to download this file once from this
          form
        </WarningHolder>
      )}

      <Button className="button-primary" onClick={save}>
        Save
      </Button>
    </>
  );
}
